import { useMemo } from "react";
import useSWR from "swr";
import {
  CATALOGUES_CACHE_KEY,
  CatalogueService,
  type Catalogue,
} from "@/services/catalogue.service";

export function useCatalogues() {
  const { data, error, isLoading } = useSWR<Catalogue[]>(
    CATALOGUES_CACHE_KEY,
    CatalogueService.getAll
  );
  // Playground choices exclude deleted entries; keep the shared cache intact
  // so catalogue management can still display and restore them.
  const catalogues = useMemo(
    () => (data || []).filter(catalogue => !catalogue.deletedAt && !catalogue.purgedAt),
    [data],
  );

  return {
    catalogues,
    isLoading,
    isError: error,
  };
}
